let rootHtml

const formatPlayerId = (id) => {
  return `0000000000${id.trim()}`.slice(-10)
}

const app = new Vue({
  el: '#app',
  data: {
    year: '',
    years: [],
    seriesList: [],
    series: {},
    seriesId: '',
    teams: [],
    pageMode: 0,
    blocks: [],
    games: [],
    isGameDetailPopup: false,
    currentGame: false,
    currentPlayers: [],
    goalRanking: [],
    isPastGameResultsPopup: false,
    pastGameHtml: '',
    cardColors: {},
    activeRound: 0,
    dragging: false,
    moved: false,
    dragStartX: 0,
    dragStartScrollLeft: 0,
    dragThreshold: 6,
    suppressNextClick: false,
    showNav: true,
    footerObserver: null,
  },
  async created() {
    // ルートhtmlを取得
    rootHtml = document.getElementsByTagName('html')[0]

    // 過去n年分の公式戦データを読み込む
    const n = 20
    const {
      data: { entries },
    } = await axios.post('/api/collections/get/series', {
      filter: {
        year: { $gte: `${dayjs().year() - n}` },
        published: true,
      },
      fields: { year: 1, shortName: 1 },
      sort: { year: -1, _o: 1, _created: 1 },
    })

    // 年度のリストを作る
    this.years = [...new Set(entries.map((item) => {
      return item.year
    }))]

    // このページで表示する年度
    this.year = query.fy || this.years[0]

    // 該当年度の公式線を抽出する
    this.seriesList = entries.filter((item) => {
      return item.year === this.year
    })

    // 表示する公式戦のID
    this.seriesId = query.srys || (this.seriesList[0] ? this.seriesList[0]._id : '')

    // 公式戦データを取得する
    if (this.seriesId) {
      const {
        data: {
          entries: [series],
        }
      } = await axios.post('/api/collections/get/series', {
        filter: {
          _id: this.seriesId,
          published: true,
        },
      })
      this.series = series

      // 試合データを取得する
      {
        const {
          data: { entries },
        } = await axios.post('/api/collections/get/games', {
          filter: {
            seriesId: this.seriesId,
            published: true,
          },
          sort: { groupId: 1, section: 1, date: 1 },
          populate: 1,
        })

        this.games = entries
      }

      // トーナメント
      if (this.isTournament) {
        const {
          data: { entries },
        } = await axios.post('/api/collections/get/blocks', {
          filter: { 'series._id': this.seriesId },
          sort: { name: 1 },
        })
        const blocks = entries
        const blockTmps = entries.reduce((obj, item) => {
          obj[item._id] = []
          return obj
        }, {})

        this.games.forEach((item) => {
          blockTmps[item.groupId].push(item)
        })

        blocks.forEach((block) => {
          block.games = blockTmps[block._id]
        })

        this.blocks = blocks
      }

      // チーム情報を取得する
      {
        const {
          data: { entries }
        } = await axios.post('/api/collections/get/seriesTeams', {
          filter: {
            seriesId: this.seriesId,
          },
          sort: { order: 1, _created: 1 },
        })

        this.teams = entries
      }

      // 選手名変換用オブジェクトを作る
      const playerNames = this.teams.reduce((names, team) => {
        return {
          ...names,
          ...(team.members.reduce((names, member) => {
            return { ...names, [formatPlayerId(member.playerId)]: member.name }
          }, {})),
        }
      }, {})

      // 得点ランキング
      // 得点を選手別に抽出する
      const goals = []
      this.games.forEach((game) => {
        // 公開済みの試合のみ得点をカウントする
        if (!game.published) {
          return
        }

        game.gameRecords.forEach((team) => {
          team.records.forEach((rec) => {
            if (rec.value.type !== 'goal' || rec.value.playerId === 'OG') {
              return
            }
            // goal!
            const playerId = formatPlayerId(rec.value.playerId)
            let player = goals.find((item) => {
              return item.id === playerId
            })
            if (!player) {
              player = {
                id: playerId,
                name: playerNames[playerId] || '-',
                team: team.team.display,
                goals: 0
              }
              goals.push(player)
            }
            player.goals += 1
          })
        })
      })

      // 並べ替える
      goals.sort((a, b) => {
        return b.goals - a.goals
      })

      // 順位付けする
      let rank = 0
      let lastGoals = 0
      const ranking = []
      for(let i = 0; i < goals.length; i += 1) {
        if (lastGoals !== goals[i].goals) {
          if (ranking.length > RANKING_LIMIT) {
            break
          }
          rank = ranking.length + 1
          lastGoals = goals[i].goals
        }
        ranking.push({ ...goals[i], rank })
      }

      this.goalRanking = ranking
    }
  },
  computed: {
    isTournament() {
      return this.series.type === 'tournament'
    },
    sections() {
      const keys = [...new Set(this.games.map((item) => {
        return item.section
      }))]
      const sections = keys.reduce((data, key) => {
        data.push({
          key,
          games: this.games.filter((item) => {
            return item.section === key
          })
        })
        return data
      }, [])
      return _.sortBy(sections, (item) => {
        return parseInt(item.key, 10)
      })
    },
  },
  mounted() {
    // ドラッグ後に発生する click を確実に潰す（captureで先に止める）
    this._clickKiller = (e) => {
      if (this.suppressNextClick) {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation?.()
        this.suppressNextClick = false
      }
    }
    document.addEventListener('click', this._clickKiller, true)

    const navHideTrigger = this.$refs.navHideTrigger
    if (navHideTrigger) {
      this.footerObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            // フッターが画面に入ったらナビを隠す
            this.showNav = !entry.isIntersecting
          })
        },
        {
          root: null,        // viewport
          threshold: 0,      // 1pxでも見えたら反応
        }
      )
      this.footerObserver.observe(navHideTrigger)
    }
  },
  beforeDestroy() {
    document.removeEventListener('click', this._clickKiller, true)

    if (this.footerObserver) {
      this.footerObserver.disconnect()
    }
  },
  methods: {
    isCurrentYear(year) {
      return year === this.year
    },
    isCurrentSeries(seriesId) {
      return this.seriesId === seriesId
    },
    dateFormat(date) {
      return dayjs(date).format('YYYY/MM/DD(dd) HH:mm')
    },
    teamName(game, idx) {
      return (
        _.get(game, `gameRecords.${idx}.team.display`, '') ||
        _.get(game, `gameRecords.${idx}.team.shortName`, '（未定）')
      )
    },
    isTournamentWithoutPlay(game) {
      return this.isTournament && ((game.gameRecords[0].manualGoals > 0 ) || (game.gameRecords[1].manualGoals > 0 ))
    },
    isPk(game) {
      return parseInt(_.get(game, `gameRecords.0.pk`, 0)) + parseInt(_.get(game, `gameRecords.1.pk`, 0)) > 0
    },
    async openGameDetail(game) {
      this.currentGame = game

      this.currentPlayers = game.gameRecords.reduce((arr, item) => {
        const member = _.get(_.find(this.teams, { _id: item.team._id }), 'members', [])
        return [ ...arr, ...member ]
      }, [{ playerId: 'OG', name: 'OG' }])

      // モーダルを開く
      this.isGameDetailPopup = true
      rootHtml.classList.add('is-clipped')

      this.$nextTick(() => {
        this.$refs.gameDetail.scrollTop = 0
      })
    },
    closeGameDetail() {
      this.isGameDetailPopup = false
      rootHtml.classList.remove('is-clipped')
    },
    async openPastGameResuls() {
      const {
        data: {
          content: { rendered }
        }
      } = await axios.get(`https://${location.host}/wp-json/wp/v2/pages/${PAST_GAMES_PAGE_ID}`)
      this.pastGameHtml = rendered
      this.isPastGameResultsPopup = true
      rootHtml.classList.add('is-clipped')
    },
    closePastGameResults() {
      this.isPastGameResultsPopup = false
      rootHtml.classList.remove('is-clipped')
    },
    onItemClick(round, e) {
      // moved判定が間に合わずclickが来た場合の保険
      if (this.suppressNextClick) {
        e.preventDefault()
        e.stopPropagation()
        return
      }
      this.scrollToRound(round)
    },
    scrollToRound(round) {
      const targetId = `round-${round}`
      const el = document.getElementById(targetId)
      if (!el) return

      const rect = el.getBoundingClientRect()
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop
      const targetTop = rect.top + scrollTop - 120

      smoothScrollTo(targetTop, 250)

      this.activeRound = round
    },
    onWheel(e) {
      const el = this.$refs.navInner
      if (!el) return
      const delta = e.deltaY || e.deltaX
      el.scrollLeft += delta
    },
    onDragStart(e) {
      const el = this.$refs.navInner
      if (!el) return
      this.dragging = true
      this.moved = false
      this.dragStartX = e.pageX
      this.dragStartScrollLeft = el.scrollLeft
    },
    onDragMove(e) {
      if (!this.dragging) return
      const el = this.$refs.navInner
      if (!el) return

      const dx = e.pageX - this.dragStartX

      // 一定距離を超えたらドラッグ確定
      if (!this.moved && Math.abs(dx) > this.dragThreshold) {
        this.moved = true
      }

      if (this.moved) {
        el.scrollLeft = this.dragStartScrollLeft - dx
      }
    },
    onDragEnd() {
      if (!this.dragging) return
      this.dragging = false

      // ドラッグしていたなら、直後の click を1回だけ無効化
      if (this.moved) {
        this.suppressNextClick = true
        // movedはここで戻す（次回に影響させない）
        this.moved = false
      }
    },
  },
})